import React, { forwardRef } from "react";
import "./PrintBill.css"
import { useTranslation } from "react-i18next";
import { getCurrentLocale } from "../../i18n/locale";

const PrintBill = forwardRef(({OrderAndChargesDetails=0, tableName=0, subTotal=0, cgstAmount=0, sgstAmount=0, serviceChargeAmount=0, appliedDiscount=0,
                              grandTotal=0, orderMode=0, billDetails=0, roundOff=0, payableAmount=0, packagingCharge=0, deliveryCharge=0 }, ref) => {
  const { t } = useTranslation();

  const today = new Date();
  const user = JSON.parse(localStorage.getItem("admin_token_info")) || {};

  return (
    <div ref={ref} className="receipt">

      <div className="receipt-header">
        <h3>{user.restaurantName}</h3>
        <p>{user.restaurantAddress}</p>
        <p>{t("Phone")}: {user.restaurantPhone} &nbsp; | &nbsp; {user.restaurantEmail}</p>
        {OrderAndChargesDetails?.charges?.gstNumber !== "" || undefined && (
          <p>GSTIN: {OrderAndChargesDetails.charges.gstNumber}</p>
        )}
      </div>

      <div className="receipt-info">
        <p>{orderMode} : {tableName || ""} &nbsp; | &nbsp; {t("Bill No.")}: {billDetails?.billNumber || 0}</p>
        <p>{t("Cashier")}: {user.name}</p>
        {billDetails?.tokenNumber !== null && (
          <p>{t("Token Number")}: {billDetails?.tokenNumber || ""}</p>
        )}
        <p>
            {new Intl.DateTimeFormat(getCurrentLocale(), {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
            }).format(today)}
        </p>
      </div>

      <hr />

      <table className="receipt-table">
        <thead>
          <tr>
            <th>{t("Item")}</th>
            <th>{t("Qty")}</th>
            <th>{t("Amt")}</th>
          </tr>
        </thead>

        <tbody>
          {OrderAndChargesDetails.orders?.map((item, i) => (
            <tr key={i}>
              <td>{item.name || item.foodName}
                 {item.addonSummary && (
                        <small style={{ color: "#6b7280", display: "block", fontSize: "11px" }}>
                          {item.addonSummary}
                        </small>
                   )}
                   {Array.isArray(item.selectedAddons) && item.selectedAddons.length > 0 && (
        <div style={{ color: "#6b7280", fontSize: "11px", marginTop: "2px" }}>
          {t("Add-ons")}:
          {item.selectedAddons.map((addon, idx) => (
            <div key={addon.addonItemId || idx}>
              {addon.itemName} (+₹{addon.price})
            </div>
          ))}
        </div>
      )}
                  {(item.hsnSacCode || item.isTaxExempt || item.taxCategoryName) && <small style={{ color: "#6b7280", display: "block", fontSize: "10px" }}>{item.hsnSacCode ? `HSN/SAC ${item.hsnSacCode} · ` : ""}{item.isTaxExempt ? "Tax exempt" : item.taxCategoryName || ""}</small>}
              </td>
              <td>{item.quantity || item.selected}</td>
              <td>{ (item.quantity * item.price) || (item.selected * item.price)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr />

      <div className="receipt-summary">

        <div className="row">
          <span>{t("Sub Total")}</span>
          <span>₹{subTotal.toFixed(2)}</span>
        </div>

        {serviceChargeAmount > 0 && (
          <div className="row">
            <span>{t("Service Charge")}</span>
            <span>₹{serviceChargeAmount.toFixed(2)}</span>
          </div>
        )}

        {packagingCharge > 0 && (
          <div className="row">
            <span>{t("Packaging Charge")}</span>
            <span>₹{Number(packagingCharge).toFixed(2)}</span>
          </div>
        )}

        {(deliveryCharge > 0 || Number(billDetails?.deliveryCharge || 0) > 0) && (
          <div className="row"><span>{t("Delivery Charge")}</span><span>₹{Number(deliveryCharge || billDetails?.deliveryCharge).toFixed(2)}</span></div>
        )}

        {cgstAmount > 0 && (
          <div className="row">
            <span>CGST</span>
            <span>₹{cgstAmount.toFixed(2)}</span>
          </div>
        )}

        {sgstAmount > 0 && (
          <div className="row">
            <span>SGST</span>
            <span>₹{sgstAmount.toFixed(2)}</span>
          </div>
        )}

        {appliedDiscount > 0 && (
          <div className="row">
            <span>{t("Discount")}</span>
            <span>-₹{appliedDiscount.toFixed(2)}</span>
          </div>
        )}

        <hr />

        <div className="row total">
          <span>{t("Total")}</span>
          <span>₹{grandTotal.toFixed(2)}</span>
        </div>

         <div className="row total">
          <span>{t("Round Off")}</span>
          <span>₹{roundOff}</span>
        </div>

         <div className="row total">
          <span>{t("Payable Amount")}</span>
          <span>₹{payableAmount.toFixed(2)}</span>
        </div>

      </div>

      <hr />

      <div className="receipt-footer">
        <p>{t("Thank You! Visit Again")} 🙏</p>
        {t("Powered by ARK tech")}
      </div>

    </div>
  );
});

export default PrintBill;
